<template>
  <v-container fluid class="tenant-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Tenant</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                    <v-row justify="center">
                      <v-col cols="12" md="3" sm="6">
                      <v-form>
                        <p class="text-h5">New Tenant</p>
                        <v-text-field
                          class="mb-4"
                          v-model="tenant.tenantname"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Tenant Name"
                          persistent-hint
                          single-line hint="Enter the tenantname">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="tenant.tenantcontact"
                          outlined
                          dense
                          placeholder="Contact Person"
                          persistent-hint
                          single-line hint="Enter the contact person">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="tenant.tenantemail"
                          outlined
                          dense
                          placeholder="Email"
                          persistent-hint
                          single-line hint="Enter the tenant email">
                        </v-text-field>
                        <v-row no-gutters>
                          <v-col cols="12" md="6">
                            <v-switch
                              v-model="tenant.tenantstatus"
                              color="primary"
                              v-bind:label="tenant.tenantstatus=='Active' ? tenant.tenantstatus : 'Inactive'"
                              value="Active"
                              false-value="Inactive"
                              hint="Status"
                              persistent-hint
                            ></v-switch>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-switch
                              color="primary"
                              v-model="tenant.isReceiptNotify"
                              hint="Notify Receipt"
                              :false-value="false"
                              persistent-hint
                            ></v-switch>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3" sm="6">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-textarea
                          v-model="tenant.tenantaddress"
                          outlined
                          rows=3
                          label="Address"
                          hint="please enter the tenant address"
                        ></v-textarea>
                        <v-text-field
                          class="mb-4"
                          v-model="tenant.tenantphone"
                          outlined
                          dense
                          placeholder="Phone"
                          persistent-hint
                          single-line hint="Enter the tenant phone">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="tenant.tenantmobile"
                          outlined
                          dense
                          placeholder="Mobile"
                          persistent-hint
                          single-line hint="Enter the tenant mobile">
                        </v-text-field>

                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3" sm="6">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          :items="tenanttypes"
                          class="mb-4"
                          v-model="tenant.tenanttype"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the tenant type">
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="tenant.unitnum"
                          outlined
                          dense
                          placeholder="Unit Num"
                          persistent-hint
                          single-line hint="Enter the unit num">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items="properties.map(x => {return {text: x.propertyname, value: x._id};})"
                          v-model="tenant.propertyid"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Property"
                          persistent-hint
                          single-line hint="Please choose the property">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="regions.map(x => {return {text: x.regionname, value: x._id};})"
                          v-model="tenant.regionid"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Region"
                          persistent-hint
                          single-line hint="Please choose the region">
                        </v-select>

                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="9">
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/tenant/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertTenant()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="3"></v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      imageurl: undefined,
      tenant: {
        tenantstatus: 'Active',
        tenantimage: null,
      },
      tenanttypes: ['Tenant', 'Other Tenant'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },
  computed: {
    ...mapState('Property', ['properties']),
    ...mapState('Region', ['regions']),
    ...mapState('Tenant', ['isReceiving']),
  },
  methods: {
    ...mapActions('Property', ['getPropertiesRequest']),
    ...mapActions('Region', ['getRegionsRequest']),
    ...mapActions('Tenant', ['insertTenantRequest','insertTenantWithImageRequest','getTenantsRequest']),
    checkError(){
      if(!this.tenant.tenantname){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.tenant.tenanttype){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.tenant.propertyid){
        this.haserrors = true;
        this.errorindex = 4;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async insertTenant() {
      this.tenant.tenantstatus = this.tenant.tenantstatus=='Active' ? this.tenant.tenantstatus : 'Inactive';
      if(this.tenant.tenantimage!=null) await this.insertTenantWithImageRequest(this.tenant);
      else await this.insertTenantRequest(this.tenant);
      router.push('/tenant/list');
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.tenant.tenantimage = file;
      this.tenant.imagename = file.name;
      this.createImage(file);
    }
  },

  async created(){
    if(this.properties.length==0) await this.getPropertiesRequest();
    if(this.regions.length==0) await this.getRegionsRequest();
  }
}
</script>
<style src="./Add.scss" lang="scss"></style>
